import React from 'react';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';

import { ReactComponent as LennarLogo } from '../assets/lennar-logo.svg';
import backArrowSvg from '../assets/back-arrow.svg';
import personSvg from '../assets/person.svg';
import { IconButton } from '../components/buttons';

export default function Header ({ dispatch }) {
  return (
    <Stack
        direction='row'
        alignItems='center'
        justifyContent='space-between'
        sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          px: 3,
          py: 5,
        }}
      >
        <Stack
          direction='row'
          alignItems='center'
          spacing={4}
          zIndex={10}
        >
          <Box sx={{ 'svg path': { fill: '#FFFFFF' } }}>
            <LennarLogo />
          </Box>
        </Stack>

        <Stack
          direction='row'
          spacing={2}
          zIndex={10}
        >
          <IconButton>
            <img src={personSvg} alt='' />
          </IconButton>
        </Stack>
      </Stack>
  );
}
